import gridHeight from '../../core/shared-service/grid-utils';
import templateUrl from './routing-code.html';
import moment from 'moment';
import angular from "angular";

export const routingCodes = {
    templateUrl,
    bindings: {
        invitedEntity: '<', // Les données d'une sous-entité.,
        principal: '<' // Le donneur d'ordre
    },
    controllerAs: 'ctrl',
    controller: class RoutingCodes {
        /*@ngInject*/
        constructor($translate, RoutingCodeSvc, PrincipalSvc, SessionSvc, $scope, $rootScope, $uibModal, logger) {
            this.$translate = $translate;
            this.gridApi = null;
            this.routingCodeSvc = RoutingCodeSvc;
            this.PrincipalSvc = PrincipalSvc;
            this.SessionSvc = SessionSvc;
            this.scope = $scope;
            this.$rootScope = $rootScope;
            this.$uibModal = $uibModal;
            this.logger = logger;
        }

        $onInit() {
            this.$rootScope.$on('routingCodeUpdated', () => {
                this.search();
                this.gridApi.core.refresh();
            });

            this.subEntity = angular.copy(this.invitedEntity.subEntity);
            //variable permettant de voir si on doit afficher le bouton d'activation du bouton pdp réception
            this.disableBtnPdpRe = true;
            this.showPdpRe = false;

            this.defaultCellTemplate =
                '<div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.ctrl.updateRouting(row.entity)">{{COL_FIELD CUSTOM_FILTERS}}</div>';
            this.routingCodesGridOptions = {
                columnDefs: [
                    {
                        name: 'code',
                        displayName: 'kiss_seller.edit.routing_code.code',
                        headerCellFilter: 'translate',
                        cellFilter: 'translate',
                        cellTemplate: this.defaultCellTemplate,
                        cellClass: 'cursor-default',
                        sort: {direction: 'asc', priority: 0}
                    },
                    {
                        name: 'label',
                        displayName: 'kiss_seller.edit.routing_code.label',
                        headerCellFilter: 'translate',
                        cellTemplate: this.defaultCellTemplate,
                        cellClass: 'cursor-default'
                    },
                    {
                        name: 'getStatusLabel()',
                        displayName: 'kiss_seller.edit.routing_code.status.title',
                        headerCellFilter: 'translate',
                        width: '8%',
                        cellTemplate: this.defaultCellTemplate,
                        cellClass: 'cursor-default'
                    },

                ],
                exporterOlderExcelCompatibility: false,
                useExternalPagination: false,
                useExternalSorting: false,
                enableRowSelection: this.showPdpRe,
                onRegisterApi: gridApi => this.onRegisterApi(gridApi),
                enableSorting: true,
                enableGridMenu: false,
                enableColumnMenus: false,
                paginationPageSizes: [5, 10, 20],
                paginationPageSize: 5,
                data: {}
            };

            this.search();
        }

        onRegisterApi(gridApi) {
            this.gridApi = gridApi;
            if (gridApi.selection) {
                gridApi.selection.on.rowSelectionChanged(this.scope, () => {
                    this.isRoutingCodeSelected();
                });
                gridApi.selection.on.rowSelectionChangedBatch(this.scope, () => {
                    this.isRoutingCodeSelected();
                });
            }
        }

        getGridHeight() {
            return gridHeight(this.gridApi, this.routingCodesGridOptions.rowHeight);
        }

        /**
         * Export csv
         */
        exportCsv() {
            this.routingCodesGridOptions.exporterCsvFilename = `codes-routage-etablissements_${
                this.invitedEntity.subEntity.id
            }_${moment().format('DDMMYYYY')}.csv`;
            this.routingCodesGridOptions.exporterHeaderFilter = this.$translate.instant;
            this.gridApi.exporter.csvExport('all', 'all');
        }

        /**
         * Recherche des codes routage
         */
        search() {
            this.routingCodesGridOptions.data = this.routingCodeSvc.getRoutingCodes(this.subEntity.id).then(
                entities => {
                    this.routingCodesGridOptions.data = entities;
                    this.showPdpRe = this.canEditPdpRe();
                    if(this.showPdpRe) this.insertPdpColumns();
                }
            );
        }

        insertPdpColumns(){
            this.routingCodesGridOptions.columnDefs[0].width = '16%';
            const pdpColumns = [
                {
                    name: 'getPdpReDate("startDate")',
                    displayName: 'kiss_seller.edit.pdp_re.start_date',
                    headerCellFilter: 'translate',
                    cellTemplate: this.defaultCellTemplate,
                    cellClass: 'cursor-default text-center',
                },
                {
                    name: 'getPdpReDate("endDate")',
                    displayName: 'kiss_seller.edit.pdp_re.end_date',
                    headerCellFilter: 'translate',
                    cellTemplate: this.defaultCellTemplate,
                    cellClass: 'cursor-default text-center',
                },
            ]
            this.routingCodesGridOptions.columnDefs.push(...pdpColumns);
        }

        updateRouting(row) {
           this.scope.$emit('fetchRoutingCodes', row);
        }

        activatePdpReForSubEntities() {
            this.updatePdpForRoutingCodes();
        }

        /**
         * Récupération des ids sélectionnés
         */
        getRoutingCodeIdsSelected() {
            let ids = [];
            if  (!(this.gridApi === undefined || this.gridApi.selection === undefined)){
                let selectedRows = this.gridApi.selection.getSelectedRows();
                for (const element of selectedRows) {
                    ids.push(element.id);
                }
            }
            return ids;
        }

        isRoutingCodeSelected() {
            const selectedRows = this.gridApi.selection.getSelectedRows();
            this.disableBtnPdpRe = !(selectedRows.length > 0);
        }

        /**
         * Mise à jour des pdp réception codes routage
         */
        updatePdpForRoutingCodes() {
            this.$uibModal
                .open({
                    component: 'modalPdpReRoutingCode',
                    size: 'md',
                    resolve: {
                        nbRoutingCodes: () => {
                            return this.getRoutingCodeIdsSelected().length;
                        }
                    },
                }).result.then(
                (dates) => {
                    let LegalEntitiesPlatformPartnerHistoryDto ={
                        entitiesIds: this.getRoutingCodeIdsSelected(),
                        pdp:{
                            startDate:dates.pdpStartDate,
                            endDate:dates.pdpEndDate
                        }
                    }
                    this.PrincipalSvc.createOrUpdateRoutingCodePdp(LegalEntitiesPlatformPartnerHistoryDto).then(
                        (data) => {
                            if(data.length != this.getRoutingCodeIdsSelected().length)
                                this.logger.success('Les codes routages ont été mises à jour');
                            if(data.length !=0 )
                            {
                                this.$uibModal
                                    .open({
                                        component: 'modalUnUpdatePdpRoutingCode',
                                        size: 'md',
                                        resolve: {
                                            routingCode: () => {
                                                return data;
                                            }
                                        },
                                    })
                            }

                        }
                    )

                }
            );
        }

        // afficher le bloc Pdp réception si au moins l'un des pays des sous entités fait partie de la France métropolitaine et outre-mer
        canEditPdpRe() {
            return (
                this.subEntity.id !== null &&
                this.PrincipalSvc.getSocFr().includes(this.subEntity.countryCode) &&
                this.principal.principal.detail.profilBuyer
            );
        }
    }
};
